// @flow

import React from "react";
import cloneDeep from "lodash/cloneDeep";
import { LEVEL_STATUS } from "buba-components-ts/src/components/Workflow/types";
import CreatorFeedbackModal from "./CreatorFeedbackModal";
import paths from "../../data/paths";
import { SKIPPED } from "../../data/guaranteeInterestOptions";

const creatorFeedbackModal = (inquiryId, financingProcess) => {
  return <CreatorFeedbackModal inquiryId={inquiryId} financingProcess={financingProcess} />;
};

const cloneWorkflowItem = item => {
  if (!item) {
    return item;
  }

  return {
    ...item,
    actions: item.actions?.map(action => ({ ...action })),
    statusLabels: cloneDeep(item.statusLabels)
  };
};

const workflowItems = {
  inquiry_submitted: {
    heading: "Ihr Vorhaben wurde erfolgreich übermittelt",
    label:
      "Ihr Vorhaben wurde der zuständigen Bürgschaftsbank übermittelt. Falls Sie Fragen haben sollten, sprechen Sie uns gerne an!"
  },
  awaiting_fides_sync: {
    heading: "Wir bereiten die Antragsdaten für Sie auf",
    label:
      "Nach positiver Ersteinschätzung erstellen bzw. aktualisieren wir für Sie und Ihren Kunden die Antragsdokumente. Sobald der Antrag bereitsteht, werden wir Sie per Mail darüber informieren.",
    statusLabels: {
      active: {
        heading: "Wir bereiten die Antragsdaten für Sie auf",
        label:
          "Nach positiver Ersteinschätzung erstellen bzw. aktualisieren wir für Sie und Ihren Kunden die Antragsdokumente. Sobald der Antrag bereitsteht, werden wir Sie per Mail darüber informieren."
      },
      active_change_requested: {
        heading: "Wir aktualisieren den Antrag für Sie",
        label: "Sie haben einen Korrekturwunsch angegeben: {change_request}"
      },
      completed: {
        heading: "Wir bereiten die Antragsdaten für Sie auf",
        label:
          "Nach positiver Ersteinschätzung erstellen bzw. aktualisieren wir für Sie und Ihren Kunden die Antragsdokumente. Sobald der Antrag bereitsteht, werden wir Sie per Mail darüber informieren."
      },
      failed: {
        heading: "Ein technischer Fehler ist aufgetreten",
        label:
          "Ein technischer Fehler ist aufgetreten. Bei Fragen wenden Sie sich gerne an Ihren persönlichen Ansprechpartner."
      }
    }
  },
  creator_feedback: {
    actions: [
      {
        buttonLabel: "Zum Antrag"
      },
      {
        buttonLabel: "Rückmeldung geben"
      }
    ],
    heading: "Bitte Prüfen Sie den Antrag und Geben Sie uns eine Rückmeldung",
    label:
      "Hier können Sie die Vollständigkeit und Korrektheit der Antragsdaten bestätigen. Sollte etwas nicht passen, können Sie uns Ihren Korrekturwunsch mitteilen.",
    statusLabels: {
      active: {
        heading: "Bitte Prüfen Sie den Antrag und Geben Sie uns eine Rückmeldung",
        label:
          "Hier können Sie die Vollständigkeit und Korrektheit der Antragsdaten bestätigen. Sollte etwas nicht passen, können Sie uns Ihren Korrekturwunsch mitteilen."
      },
      completed: {
        heading: "Vielen Dank für Ihre Bestätigung des Antrags",
        label:
          "Vielen Dank für die Bestätigung der Vollständigkeit und Korrektheit der Antragsdaten. Wir würden uns freuen, Sie und Ihren Kunden bei dem geplanten Vorhaben unterstützen zu dürfen! Für die Aufbewahrung des Antragsformulars ist das antragsstellende Institut verantwortlich."
      },
      failed: {
        heading: "Antrag verworfen",
        label:
          "Gerne Unterstützen wir Sie und Ihre Kunden zukünftig bei anderen Vorhaben. Kommen Sie gerne auf uns zu!"
      },
      timed_out: {
        heading: "Die Frist zur Bestätigung des Antrags ist abgelaufen",
        label:
          "Sollten Sie dennoch eine Unterstützung durch die Bürgschaftsbank für das Vorhaben Ihres Kunden wünschen, kommen Sie gerne direkt auf uns zu!"
      }
    }
  },
  awaiting_fides_decision: {
    heading: "Wir prüfen Ihren Antrag",
    label:
      "Ihr Antrag wird von der zuständigen Bürgschaftsbank geprüft. Sobald eine Entscheidung bereitsteht, werden wir Sie per Mail darüber informieren.",
    statusLabels: {
      active: {
        heading: "Ihr Antrag befindet sich im Genehmigungsprozess",
        label:
          "Ihr Antrag wird von der zuständigen Bürgschaftsbank geprüft. Sobald eine Entscheidung bereitsteht, werden wir Sie per Mail darüber informieren."
      },
      completed: {
        heading: "Antrag stattgegeben",
        label:
          "Wir haben Ihren Antrag erfolgreich geprüft. Wir freuen uns, dass wir Sie und Ihren Kunden bei dem geplanten Vorhaben unterstützen dürfen!"
      },
      failed: {
        heading: "Vorgang beendet",
        label:
          "Der Antrag wurde abgelehnt oder zurückgezogen. Bei Rückfragen sprechen Sie gerne Ihren Ansprechpartner an."
      }
    }
  },
  guarantee_certificate: {
    heading: "Wir stellen Ihnen die Bürgschaftserklärung bereit",
    label:
      "Nach erfolgreicher, positiver Prüfung erhalten Sie hier die digitale Bürgschaftserklärung. Sobald die Bürgschaftserklärung bereitsteht, werden wir Sie per Mail darüber informieren.",
    actions: [
      {
        buttonLabel: "Zur Bürgschaftserklärung",
        actionIsRepetable: true
      }
    ],
    statusLabels: {
      active: {
        heading: "Ihre Bürgschaftserklärung steht zum Download bereit",
        label:
          "Wir haben Ihre digitale Bürgschaftserklärung erstellt. Sie können ab sofort hier die Bürgschaftserklärung herunterladen."
      },
      completed: {
        heading: "Sie haben die Bürgschaftserklärung erhalten",
        label:
          "Sie haben die Bürgschaftserklärung heruntergeladen. Sie können auch zu einem späteren Zeitpunkt die Bürgschaftserklärung im Unterlagenaustausch erneut herunterladen."
      },
      failed: {
        heading: "Bürgschaftserklärung",
        label:
          "Es konnte keine Urkunde automatisch bereitgestellt werden. Bitte wenden Sie sich direkt an Ihren zuständigen Ansprechpartner."
      }
    }
  },
  see_guarantee_interest: {
    statusLabels: {
      active: {
        heading: "Ihre Anfrage wird geprüft",
        label:
          "Ihre Anfrage wurde an den zuständigen Mitarbeiter weitergeleitet und wird von der Bürgschaftsbank geprüft. Sobald eine Ersteinschätzung erfolgt ist, nehmen wir zu Ihnen Kontakt auf."
      },
      completed: {
        heading: "Ihre Anfrage wurde erfolgreich geprüft",
        label:
          "Die grundlegende Prüfung Ihrer Anfrage ist erfolgt. Wir melden uns kurzfristig bezüglich der weiteren Vorgehensweise."
      },
      // shown instead of "completed" when the guarantee bank skipped the interest step
      skipped: {
        heading: "Ihre Anfrage wird weiter bearbeitet",
        label:
          "Ihre Anfrage wird durch die Bürgschaftsbank im weiteren Verfahren bearbeitet. Sobald es Neuigkeiten gibt, melden wir uns bei Ihnen."
      },
      failed: {
        heading: "Ihre Anfrage wurde abgelehnt",
        label:
          "Ihre Anfrage wurde von der Bürgschaftsbank abgelehnt. Wir würden uns dennoch freuen, Sie und Ihren Kunden bei dem nächsten Vorhaben unterstützen zu dürfen!"
      }
    }
  }
};

const generateWorkFlowItems = (
  inquiryId,
  dashboardActionsResponseData,
  assignee,
  financingProcess
) => {
  return dashboardActionsResponseData.map(action => {
    let item = cloneWorkflowItem(workflowItems[action.id]);
    switch (action.id) {
      case "assign_guarantee_agent":
        if (assignee) {
          item = { ...item, assignee };
        }
        break;
      case "awaiting_fides_sync":
        if (action.attributes.status === "active" && action.attributes.details?.creator_feedback) {
          // eslint-disable-next-line
          action.attributes.status = LEVEL_STATUS.ACTIVE_CHANGE_REQUESTED;
          item.statusLabels[LEVEL_STATUS.ACTIVE_CHANGE_REQUESTED].label = item.statusLabels[
            LEVEL_STATUS.ACTIVE_CHANGE_REQUESTED
          ].label.replace("{change_request}", action.attributes.details.creator_feedback_details);
        }
        break;
      case "creator_feedback":
        item.actions[0] = {
          ...item.actions[0],
          onClick: (actionId, history) => history.push(paths.bankInquiryApplication(inquiryId)),
          actionIsRepetable: true
        };
        if (!financingProcess?.fidesMetadata?.dataAvailable) {
          item.actions[0].isDisabled = true;
          item.actions[1].isDisabled = true;
        }
        item.actions[1].customModal = creatorFeedbackModal(inquiryId, financingProcess);
        // TODO: add logic to differentiate between timed out and failed
        break;
      case "guarantee_certificate":
        item.actions[0].onClick = (actionId, history) =>
          history.push(paths.bankInquiryDocumentsNew(inquiryId));
        item.actions[0].isDisabled = action.attributes.status === LEVEL_STATUS.FAILED;
        break;
      case "see_guarantee_interest":
        if (
          action.attributes.status === LEVEL_STATUS.COMPLETED &&
          action.attributes.details === SKIPPED
        ) {
          item.statusLabels.completed = item.statusLabels.skipped;
        }
        break;
      default:
        break;
    }
    return { ...action, ...item };
  });
};

export default generateWorkFlowItems;
